import { Suspense, lazy, type ComponentProps } from 'react'

/**
 * The install / add-a-machine section owns the inline pair scanner (PairScanner →
 * jsqr, ~250 KB). Pairing a machine is a rare, deliberate act — existing accounts
 * never open it — so loading the section through React.lazy keeps jsqr out of the
 * initial chunk (M9). It is the other eager path to the scanner besides the Humans
 * tab; both had to move for jsqr to defer.
 */
const InstallSectionImpl = lazy(() =>
  import('./InstallSection').then((m) => ({ default: m.InstallSection })),
)

type Props = ComponentProps<(typeof import('./InstallSection'))['InstallSection']>

export function InstallSectionLazy(props: Props) {
  return (
    <Suspense fallback={null}>
      <InstallSectionImpl {...props} />
    </Suspense>
  )
}
